<div class="sec-title">
    <h1>Modifier le soustraitant</h1>
</div>
<div><a class="btn btn-action" href="/soustraitants" routerLink="/soustraitants" role="button"><i class="bi bi-arrow-90deg-left"></i> retour aux soustraitants</a></div>
<form class="col-8" [formGroup]="editContractorForm" (ngSubmit)="onSubmit(editContractorForm.value)" novalidate>
    <fieldset>
        <legend>Information</legend>
        <div class="fieldset-wrap">
            <div class="form-group mb-3">
                <label for="company_name" class="form-label">Nom de la compagnie</label>
                <input type="text" class="form-control" name="company_name" id="company_name" formControlName="company_name" />
            </div>
    
            <div class="form-group mb-3">
                <label for="contact_name" class="form-label">Nom du contact</label>
                <input type="text" class="form-control" name="contact_name" id="contact_name" formControlName="contact_name" />
            </div>  
        </div>
    </fieldset>
  
    <fieldset>
        <legend>Adresse</legend>
        <div class="fieldset-wrap">
            <div class="form-group mb-3">
                <label for="address" class="form-label">Adresse</label>
                <input type="text" class="form-control" name="address" id="address" formControlName="address" />
            </div>
    
            <div class="form-group mb-3">
                <label for="address2" class="form-label">Adresse 2</label>
                <input type="text" class="form-control" name="address2" id="address2" formControlName="address2" />
            </div>
    
            <div class="form-group mb-3">
                <label for="city" class="form-label">Ville</label>
                <input type="text" class="form-control" name="city" id="city" formControlName="city" />
            </div>
        
            <div class="form-group mb-3">
                <label for="province" class="form-label">Province</label>
                <input type="text" class="form-control" name="province" id="province" formControlName="province" />
            </div>

            <div class="form-group mb-3">
                <label for="postalcode" class="form-label">Code postale</label>
                <input type="text" class="form-control" name="postalcode" id="postalcode" formControlName="postalcode" />
            </div>
        
            <div class="form-group mb-3">
                <label for="country" class="form-label">Pays</label>
                <input type="text" class="form-control" name="country" id="country" formControlName="country" />
            </div>
        </div>
    </fieldset>
  
    <fieldset>
        <legend>Contact</legend>
        <div class="fieldset-wrap">
            <div class="form-group mb-3">
                <label for="phone" class="form-label">Téléphone</label>
                <input type="text" class="form-control" name="phone" id="phone" formControlName="phone" />
            </div>

            <div class="form-group mb-3">
                <label for="mobile" class="form-label">Céllulaire</label>
                <input type="text" class="form-control" name="mobile" id="mobile" formControlName="mobile" />
            </div>

            <div class="form-group mb-3">
                <label for="fax" class="form-label">Fax</label>
                <input type="text" class="form-control" name="fax" id="fax" formControlName="fax" />
            </div>

            <div class="form-group mb-3">
                <label for="email" class="form-label">Courriel</label>
                <input type="text" class="form-control" name="email" id="email" formControlName="email" />
            </div>
        </div>
    </fieldset>
  
    <button type="submit" class="btn btn-primary">Enregistrer</button>
    <hr/>
</form>